(function($) {
  'use strict';

  var slideout = {
    dom: function() {},

    classes: {
      'active' : 'slideout-active',
      'transition' : 'slideout-opening',
    },

    open: function($target) {
      $target.data('open', true);
      $target.addClass(slideout.classes.transition);
      setTimeout(function() {
        $target.addClass(slideout.classes.active);
      }, 300);
    },

    close: function($target) {
      $target.removeClass(slideout.classes.active);
      setTimeout(function() {
        $target.removeClass(slideout.classes.transition);
        $target.data('open', false);
      }, 300);
    },

    actions: function() {
      var $target;

      $(document).on('click', '[data-slideout]', function(event) {
        event.preventDefault();
        var id = $(this).data('slideout');
        $target = id === 'close' ? $(this).closest('.slideout') : $(id);
        if (!$target.data('open')) {
          slideout.open($target);
        }
        else {
          slideout.close($target);
        }
      });

      $(document).keyup(function(event) {
        if (event.key === "Escape" && typeof $target != 'undefined' && $target.hasClass(slideout.classes.active)) {
          slideout.close($target);
        }
      });
    },

    ready: function() {
      this.dom();
      this.actions();
    }
  };

  $(function() { slideout.ready(); });

})(jQuery);
